<template>
  <div class="h5SignPageHeaderWrapper">
    <img class="h5Logo" src="@/assets/images/CwLogo.svg" alt="" />
    <!-- H5语言切换 -->
    <LangSelect />
  </div>
</template>

<script>
import LangSelect from "@/components/common/LangSelect.vue";

export default {
  name: "H5SignPageHeader",
  components: {
    LangSelect,
  },
};
</script>

<style scoped lang="less">
.h5SignPageHeaderWrapper {
  min-height: 44px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.h5Logo {
  margin-left: 16px;
  height: 20px;
  min-width: 110px;
  padding-left: 0;
  cursor: pointer;
  object-fit: cover;
}
</style>
